import { useTranslation } from "react-i18next";
import React, { MouseEvent, useEffect, useState } from "react";

import styles from "@app/assets/styles/connection.module.scss";

import { Locales } from "@app/types/question";

import { getLanguage, setLanguage } from "@app/i18n/languageStorage";

export interface SettingsModalProps {
  isOpen: boolean;
  closeRequest: () => void;
  onSave?: (language: Locales) => void;
}

export default function SettingsModal(props: SettingsModalProps) {
  const { isOpen, closeRequest, onSave } = props;
  const { t } = useTranslation();

  const [language, setSelectedLanguage] = useState<Locales>(getLanguage());

  useEffect(() => {
    if (isOpen) {
      setSelectedLanguage(getLanguage());
    }
  }, [isOpen]);

  function onBackdropClick(e: MouseEvent<HTMLDivElement>) {
    if (e.target === e.currentTarget) {
      closeRequest();
    }
  }

  function saveLanguageAndClose() {
    setLanguage(language);
    onSave?.(language);
    closeRequest();
  }

  if (!isOpen) return null;

  return (
    <div className={styles.modalWrapper} onClick={onBackdropClick}>
      <div className={styles.modalView} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalTitle}>{t("settings.title")}</div>

        <div className={styles.radioGroup}>
          <label className={styles.radioOption}>
            <input
              type="radio"
              name="language"
              value="fr"
              checked={language === "fr"}
              onChange={() => setSelectedLanguage("fr")}
            />
            <span>{t("settings.french")}</span>
          </label>

          <label className={styles.radioOption}>
            <input
              type="radio"
              name="language"
              value="en"
              checked={language === "en"}
              onChange={() => setSelectedLanguage("en")}
            />
            <span>{t("settings.english")}</span>
          </label>
        </div>

        <div className={styles.modalActions}>
          <button
            type="button"
            className={styles.modalSecondaryButton}
            onClick={closeRequest}
          >
            {t("settings.close")}
          </button>
          <button
            type="button"
            className={styles.modalPrimaryButton}
            onClick={saveLanguageAndClose}
          >
            {t("settings.confirm")}
          </button>
        </div>
      </div>
    </div>
  );
}